export default __webpack_public_path__ + "static/media/java.f5dd86c3.png";